import { gql } from 'urql';

const UPDATE_OBJECTIVE = gql`
  mutation UpdateObjective(
    $_set: objectives_set_input!
    $id: Int!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    update_objectives_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
    }

    insert_objectives_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default UPDATE_OBJECTIVE;
